import {configuratorState} from "../../state";

const FormatFeaturesData = (mainFeaturesSectionMenus) => {
  
  /*
    ---------------------------------------------------------------------------
     main features menu
  */
  const mainFeaturesMenus = JSON.parse(JSON.stringify(mainFeaturesSectionMenus));
  
  const featuresMenu = {
    'selectedFeaturePartsGroup': '',
    menu: []
  };
  
  mainFeaturesMenus.forEach((item, index) => {
    
    // set default
    if (index === 0) featuresMenu['selectedFeaturePartsGroup'] = item.title;
    
    featuresMenu.menu.push({
      title: item.title,
      link: item.link,
    });
  });
  
  // console.log('1  ---------------------------------------')
  // console.log('featuresMenu', featuresMenu)
  // console.log('-------------------------------------------')
  
  configuratorState.featuresMenu = featuresMenu;
  
  /*
     ---------------------------------------------------------------------------
     main parts menu
  */
  const mainPartsMenu = JSON.parse(JSON.stringify(mainFeaturesSectionMenus));
  const partsMenu = {};
  
  mainPartsMenu.forEach((item) => {
    
    partsMenu[item.title] = {
      'selectedPart': item.menu[0].title,
      'selectorType': item.type,
      'menu': []
    };
    
    item.menu.forEach((part) => {
      partsMenu[item.title].menu.push({
        title: part.title,
        link: part.link,
      });
    });
  });
  
  configuratorState.mainPartsMenu = partsMenu;
  
  // console.log('2  ---------------------------------------')
  // console.log('partsMenu', partsMenu)
  // // console.log('modePartsGroupMap', modePartsGroupMap)
  // // console.log('partCheckBoxSelector', partCheckBoxSelector)
  // console.log('-------------------------------------------')
  
  /*
    ---------------------------------------------------------------------------
     parts group ref
  */
  const partsGroupRef = {};
  
  mainFeaturesSectionMenus.forEach((item) => {
    
    partsGroupRef[item.title] = {};
    
    item.menu.forEach((part) => {
      partsGroupRef[item.title][part.title] = part.groupParts;
    });
  });
  
  configuratorState.partsGroupRef = partsGroupRef;
  
  // console.log('3  ---------------------------------------')
  // console.log('partsGroupRef', partsGroupRef)
  // // console.log('modePartsGroupMap', modePartsGroupMap)
  // // console.log('partCheckBoxSelector', partCheckBoxSelector)
  // console.log('-------------------------------------------')
  
  /*
   4 ---------------------------------------------------------------------------
    parts, groups refs
  */
  const partsGroupSelectorType = {};
  const modePartsGroupMap = {};
  const partSelectorStatus = {};
  
  mainFeaturesSectionMenus.forEach((item) => {
    
    partsGroupSelectorType[item.title] = item.type;
    
    let pMenu = partSelectorStatus[item.title] = {};
    
    item.menu.forEach((part, index) => {
      
      // set defaults
      let selected = false;
      if ((item.type === 'radio' && index === 0) || item.type === 'check') {
        selected = true;
      }
      
      pMenu[part.title] = selected;
      
      part.groupParts.forEach((model) => {
        
        modePartsGroupMap[model] = {
          group: item.title,
          set: part.title
        }
      });
    });
  });
  
  let selectorsList = [];
  Object.keys(partSelectorStatus).forEach((prop) => {
    selectorsList.push(partSelectorStatus[prop])
  });
  
  
  // console.log('4  -------------------------------------------')
  //
  // // console.log(mainFeaturesSectionMenus)
  // // console.log('partSelectorStatus', partSelectorStatus)
  // // console.log('partsGroupSelectorType', partsGroupSelectorType)
  // // console.log('modePartsGroupMap', modePartsGroupMap)
  // console.log('----------------------------------------------')
  
  
  configuratorState.partsSelectorStatus = Object.assign({}, ...selectorsList);
  configuratorState.partsGroupSelectorType = partsGroupSelectorType;
  configuratorState.modePartsGroupMap = modePartsGroupMap;

  
};

export default FormatFeaturesData;
